import controller from './controller';

const template = require('./batterystatus.html');

export default {
    bindings: {
        device: '<',
        onPublishEvent: '&'
    },
    controller,
    template
};
